.full-page-entity-list-container {
    display: flex;
    flex-direction: column;
}
